import { render, staticRenderFns } from "./RestoreImportDialog.vue?vue&type=template&id=c4c1305e&scoped=true&"
import script from "./RestoreImportDialog.vue?vue&type=script&lang=js&"
export * from "./RestoreImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./restore-dialog.css?vue&type=style&index=0&id=c4c1305e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c1305e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDialog,VProgressLinear})
